import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

export const BASE_URL = `${Config.api.tender.url}`;

class BusinessIntelligenceTenantService {
  createBid(bid) {
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/bids`, bid).then((response) => response.data);
  }
  updateBid(id, bid) {
    return ApiService.put(`${BASE_URL}tenants/business-intelligence/bids/${id}`, bid).then((response) => response.data);
  }
  deleteBid(id) {
    return ApiService.delete(`${BASE_URL}tenants/business-intelligence/bids/${id}`).then((response) => response.data);
  }
  getAllBidsByTenderIds(ids) {
    // endpoint expects an array of tender ids
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/bids/tender-ids`, ids).then(
      (response) => response.data,
    );
  }
  createAward(award) {
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/awards`, award).then((response) => response.data);
  }
  updateAward(id, award) {
    return ApiService.put(`${BASE_URL}tenants/business-intelligence/awards/${id}`, award).then(
      (response) => response.data,
    );
  }
  deleteAward(id) {
    return ApiService.delete(`${BASE_URL}tenants/business-intelligence/awards/${id}`).then((response) => response.data);
  }
  getAllAwardsByTenderIds(ids) {
    // endpoint expects an array of tender ids
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/awards/tender-ids`, ids).then(
      (response) => response.data,
    );
  }
  createPotentialBidder(potentialBidder) {
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/interested-tenderers`, potentialBidder).then(
      (response) => response.data,
    );
  }
  updatePotentialBidder(id, potentialBidder) {
    return ApiService.put(`${BASE_URL}tenants/business-intelligence/interested-tenderers/${id}`, potentialBidder).then(
      (response) => response.data,
    );
  }
  deletePotentialBidder(id) {
    return ApiService.delete(`${BASE_URL}tenants/business-intelligence/interested-tenderers/${id}`).then(
      (response) => response.data,
    );
  }
  getAllPotentialBiddersByTenderIds(ids) {
    // endpoint expects an array of tender ids
    return ApiService.post(`${BASE_URL}tenants/business-intelligence/interested-tenderers/tender-ids`, ids).then(
      (response) => response.data,
    );
  }
}

export const businessIntelligenceTenantService = new BusinessIntelligenceTenantService();
